var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"mb-6 mb-md-16",attrs:{"align":"start","justify":"end"}},[_c('v-col',{attrs:{"cols":"12","md":"10"}},[_c('generic-list-item',{attrs:{"content":_vm.content,"index":_vm.index,"momentum":_vm.momentum}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }